import React from 'react';

import { ChevronRightRegularIcon } from '../../../../../../shared/icons/icons';

import './product-list-profile-chip.scss';

interface ProductListProfileChipProps {
  children: React.ReactNode;
  onClick: () => void;
}

function ProductListProfileChip(props: ProductListProfileChipProps) {
  const { children, onClick } = props;

  return (
    <button onClick={onClick} styleName="container">
      <div styleName="label">{children}</div>
      <ChevronRightRegularIcon styleName="icon" />
    </button>
  );
}

export default ProductListProfileChip;
